var $ = require( "jquery" );


require("./gsap.min.js");
require("./ScrollTrigger.min.js");
const SplitType = require("./SplitType.min.js");
require("./Menu.js")($);
require("./dropdown.js")($);
require("./interactiveMap.js")($);
require('./LigthBox.js')($);
require("./Swiper.js");
require("./TestimonialsVideos.js");
require("./Accordion.js");
require('./Isotope.js');
require('./Historique.js');
require('./collapse.js')($);
require('./forms.js')($);
require('./ScrollSpy.js');
require('./animations.js')($, gsap, ScrollTrigger, SplitType);


